import React from 'react';
import { MemberSidebarLayout } from './SidebarLayout';
import { Card, CardContent } from './ui/card';
import { Mail, MessageSquare, FileText, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

export function HelpCenterPage() {
  return (
    <MemberSidebarLayout>
      <div className="p-6 lg:p-8">
        <div className="mb-8">
          <h1 className="font-outfit text-2xl sm:text-3xl font-semibold text-white">Help Center</h1>
          <p className="text-[#A0B4CC] mt-1">Find answers and get support</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-8">
          <Card className="bg-[#041A3B] border-white/10 hover:border-[#00E5FF]/30 transition-colors cursor-pointer">
            <CardContent className="p-6">
              <FileText className="w-8 h-8 text-[#00E5FF] mb-4" />
              <h3 className="font-outfit text-lg font-medium text-white mb-2">FAQs</h3>
              <p className="text-[#A0B4CC] text-sm">
                Browse frequently asked questions about memberships, wallet, and referrals.
              </p>
            </CardContent>
          </Card>

          <Card className="bg-[#041A3B] border-white/10 hover:border-[#00E5FF]/30 transition-colors cursor-pointer">
            <CardContent className="p-6">
              <Mail className="w-8 h-8 text-[#00E5FF] mb-4" />
              <h3 className="font-outfit text-lg font-medium text-white mb-2">Email Support</h3>
              <p className="text-[#A0B4CC] text-sm">
                Reach our support team at support@allglobalaccess.com
              </p>
            </CardContent>
          </Card>
        </div>

        <Card className="bg-[#041A3B] border-white/10">
          <CardContent className="p-6 space-y-6">
            <h3 className="font-outfit text-lg font-medium text-white">Common Questions</h3>
            
            {[
              {
                q: 'How does the wallet system work?',
                a: 'Your wallet tracks your participation value, which grows based on portfolio performance set by the platform.'
              },
              {
                q: 'How do referral commissions work?',
                a: 'You earn 15% from direct referrals, 10% from 2nd level, and 5% from 3rd level referrals on their subscription amount.'
              },
              {
                q: 'How do I withdraw earnings?',
                a: 'Go to your Wallet page and click "Request Withdrawal". Minimum withdrawal is PHP 100. Withdrawals are processed within 3-5 business days.'
              },
              {
                q: 'Can I change my subscription plan?',
                a: 'Yes, you can upgrade your plan at any time. Visit the Pricing page to see available plans.'
              }
            ].map((faq) => (
              <div key={faq.q} className="pb-4 border-b border-white/5 last:border-0 last:pb-0">
                <h4 className="text-white font-medium mb-2">{faq.q}</h4>
                <p className="text-[#A0B4CC] text-sm">{faq.a}</p>
              </div>
            ))}
          </CardContent>
        </Card>
      </div>
    </MemberSidebarLayout>
  );
}
